import { PropertyType } from "./property-type";
import { Device } from "./device";
import {DefaultPropertyType} from "./default-property-type";

export class DeviceProperty {
  name: string;
  value: string;
  timestamp: number;
  device: Device;
  propertyType: PropertyType | DefaultPropertyType;
  uuid: string;
}
